import { put, select } from 'typed-redux-saga';

import { setReactionAction } from '../../../../../pages/call/features/reaction';
import { selectSelfReactionType } from '../../../../../pages/call/selectors';
import { countMetrika } from '../../../../helpers/metrika';

export function* dtmfToggleHandSaga() {
    const reactionType = yield* select(selectSelfReactionType);

    if (reactionType === 'hand') {
        countMetrika('dtmf', 'command-list', 'hand-down');
        yield* put(setReactionAction({ reactionType: null, reason: 'click' }));
        return;
    }

    countMetrika('dtmf', 'command-list', 'hand-up');
    yield* put(setReactionAction({ reactionType: 'hand', reason: 'click' }));
}
